export default "__VITE_ASSET__989$_Ysy__"